function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DATA_SET_ID_TAG = Symbol('__dataSetIds__');
export var PopperCore = function () {
  function PopperCore() {
    var _this = this;

    _classCallCheck(this, PopperCore);

    this.popperMap = {};
    this.eventFlag = false;

    this.onDocumentClickCapture = function (e) {
      var target = e.target;
      var dataSetId = [];
      var ele = target;

      while (ele && ele !== document.body) {
        if (ele.nodeType === 1) {
          var id = ele.getAttribute('data-rc-id') || '';

          if (id) {
            dataSetId.push(id);
          }
        }

        ele = ele.parentNode;
      }

      e[DATA_SET_ID_TAG] = dataSetId;
    };

    this.onDocumentClick = function (e) {
      var dataSetId = e[DATA_SET_ID_TAG] || [];

      var popperList = _this.getPopperList();

      if (!dataSetId.length) {
        popperList.forEach(function (popper) {
          popper.hideAllPopover('click');
        });
        return;
      }

      var popoverIdsMap = {};
      dataSetId.forEach(function (setId) {
        var _setId$split = setId.split('___'),
            _setId$split2 = _slicedToArray(_setId$split, 2),
            type = _setId$split2[0],
            id = _setId$split2[1];

        if (type === 'popover') {
          popoverIdsMap[id] = true;
        }
      });
      var excludeIds = [];
      Object.keys(popoverIdsMap).forEach(function (popoverId) {
        popperList.forEach(function (popper) {
          var showIds = popper.getShowIds();

          if (showIds.indexOf(popoverId) >= 0) {
            var popoverUnionIds = popper.getPopover(popoverId).getUnionPopoverIds();
            excludeIds = excludeIds.concat([popoverId].concat(_toConsumableArray(popoverUnionIds)));
          }
        });
      });
      var setId = dataSetId[0];

      var _setId$split3 = setId.split('___'),
          _setId$split4 = _slicedToArray(_setId$split3, 2),
          type = _setId$split4[0],
          id = _setId$split4[1];

      if (type !== 'trigger') {
        popperList.forEach(function (popper) {
          return popper.hideAllPopover('click', excludeIds);
        });
        return;
      }

      popperList.forEach(function (popper) {
        var trigger = popper.getTrigger(id);

        if (!trigger || trigger.getTriggerType() !== 'click') {
          popper.hideAllPopover('click', excludeIds);
          return;
        }

        if (trigger.isActiveShow() && !trigger.getDisableToggleClose()) {
          popper.hideAllPopover('click', excludeIds);
          return;
        }

        popper.hideAllPopover('click', excludeIds);
        trigger.showPopper();
      });
    };
  }

  _createClass(PopperCore, [{
    key: "addPopper",
    value: function addPopper(popper) {
      this.popperMap[popper.getId()] = popper;
    }
  }, {
    key: "removePopper",
    value: function removePopper(popper) {
      var id = popper.getId();

      if (this.popperMap[id]) {
        delete this.popperMap[id];
      }

      if (!Object.keys(this.popperMap).length) {
        this.eventFlag = false;
        document.removeEventListener('click', this.onDocumentClickCapture, true);
        document.removeEventListener('click', this.onDocumentClick);
      }
    }
  }, {
    key: "initPopperCoreEvent",
    value: function initPopperCoreEvent() {
      if (!this.eventFlag) {
        this.eventFlag = true;
        document.addEventListener('click', this.onDocumentClickCapture, true);
        document.addEventListener('click', this.onDocumentClick);
      }
    }
  }, {
    key: "getPopperList",
    value: function getPopperList() {
      var _this2 = this;

      return Object.keys(this.popperMap).map(function (id) {
        return _this2.popperMap[id];
      });
    }
  }]);

  return PopperCore;
}();
export var popperCore = new PopperCore();